import { render, staticRenderFns } from "./DesignInformDCF.vue?vue&type=template&id=46901e8d&scoped=true"
import script from "./DesignInformDCF.vue?vue&type=script&lang=js"
export * from "./DesignInformDCF.vue?vue&type=script&lang=js"
import style0 from "./DesignInformDCF.vue?vue&type=style&index=0&id=46901e8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46901e8d",
  null
  
)

export default component.exports